import { combineReducers } from "redux";

import app from "./app/appReducers";
import support from "./support/supportReducers";

export default combineReducers({
    appData: app,
    supportData: support
});
